<div class="header-notification-popup">
  <div class="dialog-header">
    <h2 mat-dialog-title></h2>
    <button mat-button mat-dialog-close>
      <span class="material-icons">close</span>
    </button>
  </div>

  <div class="header-notification-contnent">
    <div class="box-labelsuper margin-top2">
      <h4>Notification Center</h4>
    </div>

    <div class="notification-dropdown-header no-notification" *ngIf="!auth.IsAuthUser()">
      
     
        <mat-label class="content" >
          Please Login to see your notification. 
        </mat-label>
     

    </div>
              <div *ngIf="auth.IsAuthUser()" >
              <button mat-menu-item class="notification-dropdown-content" *ngFor="let element of allNotification" >
                <div class="notification-section"  >
                  <div class="avatar-img">{{element.createdBySlug}}</div>
                  <div class="notification-content">
                    <div class="name-action">
                      <div class="name">{{element.createdBy}}</div>
                      <div class="notification-action">
                        {{element.subject | slice:0:20}}..
                      </div>
                      
                    </div>
                    <div class="notification-msg">
                      {{element.description | slice:0:50}}...
                    </div>
                    <div class="notification-time">
                      {{element.createdOn}}
                    </div>
                  </div>

                </div>     
              </button>
<!-- -------------- NO Notification ---------------- -->
      <div class="no-notification" *ngIf="allNotification.length==0">
          <mat-label class="content">No Notifiction</mat-label>
      </div>
      </div>
      <div class="notification-bottom" *ngIf="auth.IsAuthUser()">
        <a [routerLink]="" class="mark-read">MARK AS ALL READ</a>
        <!-- <a  class="view-all" [routerLink]="" (click)="gotoNotificationPage()">
          <mat-icon class="material-icons-outlined"> visibility </mat-icon>VIEW
          ALL</a
        > -->
      </div>
  </div>
</div>
